import React from "react";

import "./index.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="gradient-blob"></div>
    </div>
  );
};

export default Loader;
